module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    class: {
      'btn-group': _vm.buttons, 'btn-group-justified': _vm.justified, 'btn-group-vertical': _vm.vertical
    },
    attrs: {
      "data-toggle": _vm.buttons && 'buttons'
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-125eb0c8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-125eb0c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ButtonGroup.vue
// module id = 143
// module chunks = 0